<!-- 
7-24 已有 虹口 杨浦分享
7-24 新增 不容易站点分享
7-28 新增 虹口背景图
8-12 新增专题2个类型
9-9 defaultcontent css改为assets域名
10-10 新增shortVideo  短视频
 -->
<template>
  <div>
    <van-loading type="spinner" color="#1989fa" vertical v-if="!done" />
    <div
      style="
        position: fixed;
        left: 0;
        top: 0;
        bottom: 0;
        opacity: 0.5;
        height: 100%;
        width: 100%;
        z-index: 1000000;
        background: #333333;
      "
      v-if="isWeixin.show"
    >
      <p style="text-align: right; padding: 20px 40px">
        <img
          src="./assets/images/weixin.png"
          alt="在浏览器中打开"
          style="max-height: 1888px; width: 180px"
          @click="showOff"
        />
      </p>
    </div>
    <component
      :is="defaultContent"
      :view="view"
      v-if="done"
      :id="id"
      @envChange="envChange"
    ></component>
    <!-- <component :is="defaultContent"></component> -->
    <veichat :paramData="paramData">
    </veichat>
    <openVechat v-if="showOpenW"></openVechat>
  </div>
</template>

<script>
// import defaultContent from './components/defaultContent'
// import album from './components/album'
// import videoContent from './components/videoContent'
// import timeList from './components/channelTimeList'
// import list from './components/channelList'
// import shortVideo from './components/shortVideo'
// import circleDetail from './components/circleDetail'
// import mp3content from './components/mp3content'
// import share from './components/share'
const defaultContent = () => import("./components/defaultContent");
const album = () => import("./components/album");
const videoContent = () => import("./components/videoContent");
const timeList = () => import("./components/channelTimeList");
const list = () => import("./components/channelList");
const shortVideo = () => import("./components/shortVideo");
const circleDetail = () => import("./components/circleDetail");
const share = () => import("./components/share");
const mp3content = () => import("./components/mp3content");
const veichat = () => import("./components/weichat.vue");
const openVechat = () => import("./components/openWechat.vue");

export default {
  name: "index",
  components: {
    defaultContent,
    mp3content,
    circleDetail,
    share,
    album,
    videoContent,
    timeList,
    list,
    shortVideo,
    veichat,
    openVechat,
  },
  props: {},
  data() {
    return {
      defaultContent: "share",
      obj: {},
      isWeixin: this.isWeixin,
      view: {},
      done: false,
      id: "",
      title: "",
      shareImg: '',
      showOpenW: false,
      desc: "",
      paramData: {title:'',desc:'',shareImg:'',link:''},
    };
  },
  mounted() {
    this.judgeParam();
    this.judgeEnv();
    this.showOpenWechatFn();
  },
  methods: {
    getQueryString(name) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == name) {
          return pair[1];
        }
      }
      return false;
    },
    showOpenWechatFn() {
      const isOpenShare = this.getQueryString("isOpenShare");
      if (isOpenShare) {
        this.showOpenW = true;
      }
    },
    judgeParam() {
      this.getParams().then((e) => this.plan(e));
    },
    plan(e) {
      // 传入id和type，判断类型
      this.obj = e;
      if (this.obj.type === "article" && this.obj.id) {
        this.getView(this.obj.id, "defaultContent");
      } else if (this.obj.type === "album" && this.obj.id) {
        this.getView(this.obj.id, "album");
      } else if (this.obj.type === "video" && this.obj.id) {
        this.getView(this.obj.id, "videoContent");
      } else if (this.obj.type === "subject_time_page" && this.obj.id) {
        this.getListView(this.obj.id, "timeList");
      } else if (this.obj.type === "subject_page" && this.obj.id) {
        this.getListView(this.obj.id, "list");
      } else if (this.obj.type === "community-article" && this.obj.id) {
        this.getCircle(this.obj.id, "circleDetail");
      } else if (this.obj.type === "audio" && this.obj.id) {
        this.getView(this.obj.id, "mp3content");
      } else if (this.obj.type === "short-video" && this.obj.id) {
        this.getView(this.obj.id, "shortVideo");
      } else {
        this.done = true;
      }
      this.site.appIosUrl = this.site.appIosUrl + "//";
      this.site.appAnUrl = this.site.appAnUrl + "//";
      document.getElementsByTagName("link")[0].href = this.site.logo;
      console.log(this.site, "site params");
    },

    paramDeal() {
      this.desc = `更多精彩内容，下载${this.site.siteName}App`;
      this.paramData.title = this.view.title;
      this.paramData.desc = this.desc;
      this.paramData.link = window.location.href;
      if (this.view.displayResources.length > 0) {
        this.paramData.shareImg = this.view?.displayResources[0].thumbUrl || this.site.logo;
      }
      const flag = true;
      if(flag){
        const paramJson = JSON.parse(this.view.articleSetting);
        if (paramJson.configShare) {
          this.paramData.title = paramJson.configShare.title || this.view.title;
          this.paramData.desc = paramJson.configShare.summary || this.desc;
          this.paramData.link = paramJson.configShare.link || window.location.href;
          this.paramData.shareImg = paramJson.configShare.imageUrl ? paramJson.configShare.imageUrl : '';
          if (!paramJson.configShare.imageUrl) {
            if (this.view.displayResources.length > 0) {
              this.paramData.shareImg = this.view.displayResources[0].thumbUrl || this.site.logo;
            }
          }
        }
      }
      console.log('paramData',this.paramData)
    },

    // 获取稿件详情
    getView(id, type) {
      const data = {
        id: id,
      };
      this.post(this.apiUrl.content, data)
        .then((response) => {
          // 如果code不为0，为稿件参数有误
          if (response.data.code == 0) {
            this.view = response.data.data || {};
            this.defaultContent = type;
            // actionUrl
            this.site.appIosUrl = this.view.actionUrl.replace(
              "rmt://",
              this.site.appIosUrl
            );
            this.site.appAnUrl = this.view.actionUrl.replace(
              "rmt://",
              this.site.appAnUrl
            );
            this.paramDeal();
          }
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          this.done = true;
        });
    },
    // 获取稿件list
    getListView(id, type) {
      // const data = {
      //   pageNo: 1,
      //   pageSize: 3,
      //   channel: {
      //     id: id
      //   }
      // }
      const data = {
        id: id,
      };
      //  {"pageNo": 1,"pageSize": 3,"channel": {"id": "subject/0003"} }
      this.post(this.apiUrl.channel, data)
        .then((response) => {
          // 如果code不为0，认为稿件参数有误
          if (response.data.code == 0) {
            this.view = response.data.data || {};
            this.id = id;
            this.defaultContent = type;
            document.getElementsByTagName("title")[0].innerText =
              this.view.title;
          }
          // if(response.data.code == 0) {
          //   this.view = response.data.data.records || {}
          //   this.id = id
          //   this.defaultContent = type
          // }
          this.paramDeal();
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          this.done = true;
        });
    },
    // 获取quanzi
    getCircle(id, type) {
      const data = {
        id: id,
      };
      this.post(this.apiUrl.circle, data)
        .then((response) => {
          // 如果code不为0，认为稿件参数有误
          if (response.data.code == 0) {
            this.view = response.data.data || {};
            // this.id = id
            this.defaultContent = type;
            this.site.appIosUrl =
              this.site.appIosUrl + "moment_page?id=" + this.view.id;
            this.site.appAnUrl =
              this.site.appAnUrl + "moment_page?id=" + this.view.id;
            console.log(this.site.appIosUrl, "appIosUrl");
            console.log(this.site.appAnUrl, "appAnUrl");
            // document.getElementsByTagName("title")[0].innerText = this.view.content.substring(0, 20)

            this.paramDeal();
          }
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          this.done = true;
        });
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    judgeEnv() {
      const isWeixin =
        window.navigator.userAgent.indexOf("MicroMessenger") > -1;
      if (isWeixin) {
        this.isWeixin.in = true;
      }
    },
    envChange(e) {
      this.isWeixin = e;
    },
    showOff() {
      console.log(this.isWeixin.show);
      this.isWeixin.show = !this.isWeixin.show;
    },
  },
};
</script>
